import IgvText from './IgvText';
import SectionStructure from '../../../../../components/Section/SectionStructure';
import IgvApp from './IgvApp';

export default function SectionIgv() {

    
    return (

    <SectionStructure
    
            sectiontext=    { <IgvText /> }

            sectioncards=  { <IgvApp />}
    />
)
}